export default "__VITE_PUBLIC_ASSET__a1e475a8__"